export const LocalStorageKeys = {
  SYSTEM_THEME: 'kt_theme_mode_value',
  SYSTEM_LANGUAGE: 'kt_language_value'
}
